import React from 'react';

import { MainTablePage } from '../../components/MainTablePage';

import { RemindersSearchForm } from './RemindersSearchForm';
import { useDeleteRemindersFilter } from './useDeleteRemindersFilter';
import { useGetRemindersFilters } from './useGetRemindersFilters';
import { useRemindersTableColumnDefinitions } from './useRemindersTableColumnDefinitions';
import { useRemindersTableDataSource } from './useRemindersTableDataSource';
import { useSaveRemindersFilter } from './useSaveRemindersFilter';
import { useSearchReminders } from './useSearchReminders';
import { useUpdateRemindersFilter } from './useUpdateRemindersFilter';

export const RemindersPage = () => (
  <MainTablePage
    getFilters={useGetRemindersFilters}
    saveFilter={useSaveRemindersFilter}
    updateFilter={useUpdateRemindersFilter}
    deleteFilter={useDeleteRemindersFilter}
    getColumnsDefinition={useRemindersTableColumnDefinitions}
    search={useSearchReminders}
    getDataSource={useRemindersTableDataSource}
    storedFilterName="remindersFilter"
    storedPagingData="remindersPaging"
    title="Reminders"
    searchForm={RemindersSearchForm}
  />
);
